/*
 * fixparser
 * https://gitlab.com/logotype/fixparser.git
 *
 * Copyright © 2022 fixparser.io
 * Released under Commercial license. Check LICENSE.md
 */
export enum EncryptMethodEnum {
    None = 0,
    PKCS = 1,
    DES = 2,
    PKCSDES = 3,
    PGPDES = 4,
    PGPDESMD5 = 5,
    PEM = 6,
}
